import { getFirebase } from 'react-redux-firebase';

export const callAPI = async (endpoint, data) => {
  let token;
  let userId;
  const fb = getFirebase()
  const user = fb.auth().currentUser
  let jsonData = {...data}
  if(user){
    token = await user.getIdToken()
    userId = user.uid
    jsonData = {
      ...data, 
      userId
    }
  }
  // console.log("request")
  // console.log({userId, token})
  const res = await fetch(
    // `https://z286rq4r90.execute-api.us-west-2.amazonaws.com/dev/${endpoint}`, // old enpoint
    `https://ycz93envzi.execute-api.us-west-2.amazonaws.com/dev/${endpoint}`,
    {
      method: "POST",
      mode: "cors",
      // cache: "no-cache",
      headers:{
        "Content-Type": "application/json",
        // "x-api-key": "5LyWfPYhaG4XryBHwwXLD4PS6hp4oZKr42lJQopc",
        "Accept": "*/*",
        "Accept-Encoding": "gzip, deflate, br",
        "Connection": "keep-alive",
        "Authorization": token ? `Bearer ${token}` : ""
      },
      body: JSON.stringify(jsonData),
    }
  ).catch(e=>{
    console.error(e)
    return undefined
  })
  const json = await res.json()
  return json
}